/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_6Inputs */

const en_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the Activation Code in the form field above`)
};

const fr_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez le Code d'Activation dans le champ du formulaire ci-dessus`)
};

const de_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie den Aktivierungscode in das obige Formularfeld ein.`)
};

const it_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla il codice di attivazione nel campo del modulo sopra`)
};

const ru_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте код активации в поле формы выше.`)
};

const es_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegue el código de activación en el campo de formulario de arriba`)
};

const zh_cn2_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请将激活码粘贴到上方表单字段中。`)
};

const ja_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上記のフォームフィールドにアクティベーションコードを貼り付けてください`)
};

const hi_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऊपर दिए गए फॉर्म फ़ील्ड में एक्टिवेशन कोड पेस्ट करें।`)
};

const pt_pt2_login_offline_instruction_6 = /** @type {(inputs: Login_Offline_Instruction_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole o código de ativação no campo do formulário acima.`)
};

/**
* | output |
* | --- |
* | "Paste the Activation Code in the form field above" |
*
* @param {Login_Offline_Instruction_6Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_6 = /** @type {((inputs?: Login_Offline_Instruction_6Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_6Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_instruction_6(inputs)
	if (locale === "de") return de_login_offline_instruction_6(inputs)
	if (locale === "it") return it_login_offline_instruction_6(inputs)
	if (locale === "ru") return ru_login_offline_instruction_6(inputs)
	if (locale === "es") return es_login_offline_instruction_6(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_instruction_6(inputs)
	if (locale === "ja") return ja_login_offline_instruction_6(inputs)
	if (locale === "hi") return hi_login_offline_instruction_6(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_instruction_6(inputs)
	return en_login_offline_instruction_6(inputs)
});